import { render, staticRenderFns } from "./Assinatura.vue?vue&type=template&id=457fb19b&"
import script from "./Assinatura.vue?vue&type=script&lang=js&"
export * from "./Assinatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports